import script from "./cxInfoAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./cxInfoAdd.vue?vue&type=script&setup=true&lang=js"

import "./cxInfoAdd.vue?vue&type=style&index=0&id=1b31a1c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b31a1c2"]])

export default __exports__